import { __extends } from "tslib";
import { Event } from './Event';
var ContextMenuEvent = /** @class */ (function (_super) {
    __extends(ContextMenuEvent, _super);
    function ContextMenuEvent(type, bubbles, cancelable, mouseTarget, contextMenuOwner) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (mouseTarget === void 0) { mouseTarget = null; }
        if (contextMenuOwner === void 0) { contextMenuOwner = null; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        // TODO: coerce
        _this.mouseTarget = mouseTarget;
        _this.contextMenuOwner = contextMenuOwner;
        return _this;
    }
    ContextMenuEvent.classInitializer = null;
    ContextMenuEvent.classSymbols = null;
    ContextMenuEvent.instanceSymbols = null;
    // JS -> AS Bindings
    ContextMenuEvent.MENU_ITEM_SELECT = 'menuItemSelect';
    ContextMenuEvent.MENU_SELECT = 'menuSelect';
    return ContextMenuEvent;
}(Event));
export { ContextMenuEvent };
